export const API_URL = 'https://web.objectifofficiersp.com/api';
export const ROOT_URL = 'https://web.objectifofficiersp.com';
